import ErrorPage from "~modules/ErrorPage";
import withGlobalData from "~utils/nextjs/middleware/withGlobalData";
import withLayout from "~utils/withLayout";

const NotFound = (props) => <ErrorPage code={404} {...props} />;

export const getStaticProps = withGlobalData();

export default withLayout(NotFound);
